export const styles = {
	stackContainer: {
		flexGrow: 1,
		display: 'flex',
		flexDirection: 'column',
	},
	contentBox: {
		display: 'flex',
		flexDirection: 'column',
		flexGrow: 1,
		pt: 4,
		px: 4,
	},
	scrollableContent: {
		display: 'flex',
		flexDirection: 'column',
		flexGrow: 1,
		overflowY: 'auto',
		pb: 2,
	},
	containerInner: {
		display: 'flex',
		flexDirection: 'column',
		flexGrow: 1,
	},
	breadcrumbContainer: {
		padding: {
			lg: '3.2rem 9.6rem',
			md: '3.2rem 6.4rem',
			sm: '3.2rem',
			xs: '3.2rem',
		},
		'& .MuiTypography-root': {
			fontSize: '1.6rem',
		},
	},
	pageTitle: {
		mb: 3,
		textAlign: 'center',
	},
	divider: {
		mb: 4,
	},
	formLabel: {
		mb: 1,
		fontSize: '1.4rem',
		fontWeight: 500,
		color: '#000000DE',
	},
	autocompleteContainer: {
		flex: 1,
		minWidth: 0,
	},
	emailRow: {
		display: 'flex',
		flexDirection: { xs: 'column', md: 'row' },
		alignItems: { xs: 'stretch', md: 'center' },
		gap: { xs: 1, md: 2 },
		mb: 2,
	},
	addButton: {
		flexShrink: 0,
		px: 3,
	},
	usersAddedLabel: {
		mb: 1,
		fontWeight: 500,
		fontSize: '1.4rem',
		color: '#000000DE',
	},
	userListContainer: {
		flexGrow: 1,
		overflowY: 'auto',
		maxHeight: '312px',
		mb: 2,
	},
	userRow: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		px: 2,
		py: 1,
	},
	userEmail: {
		flex: 1,
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
		mr: 2,
		fontSize: '1.6rem',
		color: '#000000DE',
	},
	userRole: {
		flexShrink: 0,
		mr: 2,
		fontSize: '1.6rem',
		color: '#000000DE',
	},
	infoText: {
		color: 'secondary.light',
		mb: 2,
	},
	actionRow: {
		display: 'flex',
		flexDirection: 'column',
		gap: 2,
		py: 3,
		flexShrink: 0,
		borderTop: '1px solid',
		borderColor: 'divider',
	},
	buttonsRow: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
	},
	secondaryButton: {
		color: 'secondary.main',
	},
	rightButtons: {
		display: 'flex',
		gap: 2,
	},
}
